import Accordion from 'components/utils/Accordion';
import useTranslation from 'hooks/useTranslation';
import React, { useMemo } from 'react';

import style from './index.style';

export default function Faq({ selectedTab }) {
  const { TRANSLATIONS } = useTranslation();
  const FAQ_BSOCIAL = useMemo(
    () => ({
      faq_1: {
        question: `${TRANSLATIONS.pricing.faq.question_bsocial}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_bsocial}`,
      },
      faq_2: {
        question: `${TRANSLATIONS.pricing.faq.question_1}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_1}`,
      },
      faq_3: {
        question: `${TRANSLATIONS.pricing.faq.question_3}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_3}`,
      },
      faq_4: {
        question: `${TRANSLATIONS.pricing.faq.question_4}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_4}`,
      },
    }),
    [
      TRANSLATIONS.pricing.faq.answer_1,
      TRANSLATIONS.pricing.faq.answer_3,
      TRANSLATIONS.pricing.faq.answer_4,
      TRANSLATIONS.pricing.faq.answer_bsocial,
      TRANSLATIONS.pricing.faq.question_1,
      TRANSLATIONS.pricing.faq.question_3,
      TRANSLATIONS.pricing.faq.question_4,
      TRANSLATIONS.pricing.faq.question_bsocial,
    ]
  );
  const FAQ_DROPSHIPPING = useMemo(
    () => ({
      faq_1: {
        question: `${TRANSLATIONS.pricing.faq.question_1}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_1}`,
      },
      faq_2: {
        question: `${TRANSLATIONS.pricing.faq.question_3}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_3}`,
      },
      faq_3: {
        question: `${TRANSLATIONS.pricing.faq.question_4}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_4}`,
      },
    }),
    [
      TRANSLATIONS.pricing.faq.answer_1,
      TRANSLATIONS.pricing.faq.answer_3,
      TRANSLATIONS.pricing.faq.answer_4,
      TRANSLATIONS.pricing.faq.question_1,
      TRANSLATIONS.pricing.faq.question_3,
      TRANSLATIONS.pricing.faq.question_4,
    ]
  );
  const FAQ_TURNKEY = useMemo(
    () => ({
      faq_1: {
        question: `${TRANSLATIONS.pricing.faq.question_2}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_2}`,
      },
      faq_2: {
        question: `${TRANSLATIONS.pricing.faq.question_1}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_1}`,
      },
      faq_3: {
        question: `${TRANSLATIONS.pricing.faq.question_3}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_3}`,
      },
      faq_4: {
        question: `${TRANSLATIONS.pricing.faq.question_4}`,
        answer: `${TRANSLATIONS.pricing.faq.answer_4}`,
      },
    }),
    [
      TRANSLATIONS.pricing.faq.answer_1,
      TRANSLATIONS.pricing.faq.answer_2,
      TRANSLATIONS.pricing.faq.answer_3,
      TRANSLATIONS.pricing.faq.answer_4,
      TRANSLATIONS.pricing.faq.question_1,
      TRANSLATIONS.pricing.faq.question_2,
      TRANSLATIONS.pricing.faq.question_3,
      TRANSLATIONS.pricing.faq.question_4,
    ]
  );

  const FAQ = useMemo(() => {
    switch (selectedTab) {
      case 1:
        return FAQ_DROPSHIPPING;
      case 2:
        return FAQ_TURNKEY;
      case 3:
        return FAQ_BSOCIAL;
      default:
        return FAQ_DROPSHIPPING;
    }
  }, [FAQ_BSOCIAL, FAQ_DROPSHIPPING, FAQ_TURNKEY, selectedTab]);

  return (
    <div className="faq-container w-100 d-f jc-c fd-c ai-c mt-xl">
      <div className={`faq-head`}>
        <h4>{TRANSLATIONS.pricing.faq.title} </h4>
      </div>
      <div className="row w-100 fd-c ai-c">
        {Object.keys(FAQ).map((faq) => (
          <div className="col-xl-7 " key={faq}>
            <Accordion label={FAQ[faq]?.question} className="bot-accordion">
              {FAQ[faq]?.answer}
            </Accordion>
          </div>
        ))}
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
